import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import styled, { createGlobalStyle } from 'styled-components';

export const HtmlOverflowUnset = createGlobalStyle`
  html {
    overflow-x: unset;
  }
`;

export const StyledParagraph = styled.p`
  /* display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row; */
  max-width: 1150px;
  font-weight: 700;
  line-height: 17.4px;
  font-size: 10px;
  text-align: center;
  overflow-x: hidden;
  margin: 0;
  @media (max-width: 1074px) {
    font-weight: 600;
    font-size: 8.7px;
  }

  a {
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
  }

  @media (max-width: 834px) {
    font-size: 10px;
    text-align: left;
    width: 90%;
    font-size: 8.7px;

    display: inline-block;
  }
`;

export const BlueBar = styled.div`
  padding: 1em 12px;
  position: sticky;
  top: 88px;
  max-width: 100%;
  height: auto;
  gap: 0px;
  opacity: 1;
  background: #b5dcff;
  display: flex;
  /* align-items: center; */
  justify-content: center;
  overflow-x: hidden;
  z-index: 100;

  @media (max-width: 767px) {
    padding: 8px 16px;
    justify-content: flex-start;
  }

  img {
    width: 24px;
    height: 24px;
    margin-right: 7px;

    @media (max-width: 834px) {
      margin-bottom: 40px;
      display: inline-block;

      width: 20px;
      height: 20px;
    }
  }

  p {
    font-size: 14px !important;
    font-weight: bold !important;
    line-height: normal !important;

    ${media.md`
    font-size: 21px !important;
    font-weight: bold !important;
    line-height: 28.8px !important;
    line-height: normal !important;
  `}
  }

  a {
    margin-left: 6px;
    text-decoration: underline;
    cursor: pointer;
    font-weight: 700;
    @media (max-width: 1000px) {
      font-weight: 600;
    }
  }
`;
